import type { DeepPartial } from '@luna/utils-ts';

import type { RegularOrders } from '../../types/RegularOrders';

export const regularOrdersATFeatureConfig: DeepPartial<RegularOrders> = {
    note: true,
    validFrom: true,
    validUntil: true,
};
